import { isNativeCapacitorApp } from "@/integrations/clients/carAuction/nativeAuth";
import { hapticImpactSync } from "@/lib/native/capacitorBridge";

/** Haptic when toggling favorites — call synchronously inside onClick. */
export function hapticFavoriteToggle(): void {
  if (!isNativeCapacitorApp()) return;
  hapticImpactSync("medium");
}

/** Light tick — e.g. För dig peek threshold crossed. */
export function hapticLightTick(): void {
  if (!isNativeCapacitorApp()) return;
  hapticImpactSync("light");
}
